import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'

import './i18n'

import AppSpinner from './components/AppSpinner'
import { AlertProvider } from './contexts/AlertContext'
import { AuthProvider } from './contexts/AuthContext'
import router from './router'
import theme from './theme'

import 'react-image-gallery/styles/css/image-gallery.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <AlertProvider>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} fallbackElement={<AppSpinner />} />
      </ThemeProvider>
    </AuthProvider>
  </AlertProvider>,
)
